import { render, staticRenderFns } from "./TagItem.vue?vue&type=template&id=7deb4eac&scoped=true&"
import script from "./TagItem.vue?vue&type=script&lang=js&"
export * from "./TagItem.vue?vue&type=script&lang=js&"
import style0 from "./TagItem.vue?vue&type=style&index=0&id=7deb4eac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deb4eac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
